var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBlueSky({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "octicon",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.2c-.72-1.4-2.7-4.04-4.53-5.33C1.7.63 1.04.84.6 1.04.1 1.27 0 2.05 0 2.51c0 .46.25 3.77.42 4.32.54 1.82 2.47 2.45 4.25 2.25-2.6.38-4.92 1.33-1.88 4.71 3.33 3.46 4.57-.74 5.21-2.87.64 2.13 1.37 6.18 5.16 2.87 2.84-2.87.78-4.33-1.83-4.71 1.78.2 3.71-.43 4.25-2.25.17-.55.42-3.86.42-4.32 0-.46-.09-1.24-.6-1.47-.44-.2-1.11-.42-2.87.83A17.87 17.87 0 0 0 8 7.2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlueSky);
export default __webpack_public_path__ + "static/media/Icon-BlueSky.bc0f07baec129dc4d2f1316177cace0b.svg";
export { ForwardRef as ReactComponent };